import React from 'react';
import { Breakpoint } from '@noths/polaris-client-ribbons-base';
import { Media } from '@noths/polaris-client-ribbons-design-system';
import type { Link } from '@noths/polaris-dev-ts-types';

import type { AccordionProps } from 'src/components/molecules/Accordion';
import { Accordion } from 'src/components/molecules/Accordion';
import * as styles from '../styles';
import { AccordionContent } from './AccordionContent';

const hasCategoryDescription = (categoryDescription: string) =>
  categoryDescription && categoryDescription !== '<p></p>';

export interface HeaderCopyBlockProps {
  categoryDescription: string;
  categoryHeading: string;
  categorySubheading?: string;
  categoryLinks: Link[];
  landedOnPageOne: boolean;
  openOnMount: boolean;
}

/*
  HeaderCopyBlock renders Accordion both open and shut initially.
  The browser displays the appropriate view by leveraging media queries.
  Fresnel then subsequently changes this to conditional rendering:
  - This prevents life-cycle methods from firing in hidden components and unused html being written to the DOM.
*/
export const HeaderCopyBlock = ({
  categoryDescription,
  categoryHeading,
  categorySubheading,
  categoryLinks,
  landedOnPageOne,
  openOnMount,
}: HeaderCopyBlockProps) => {
  const accordionProps: AccordionProps = {
    buttonStyles: styles.copyBlockAccordionButton,
    titleStyles: styles.pageHeadingFontCSS,
    id: 'copy-block',
    headingLevel: 'h1',
    title: categoryHeading,
  };
  const accordionContentProps = {
    categoryDescription,
    categoryLinks,
    categorySubheading,
    enableCopyBlockContent: landedOnPageOne,
  };

  return (
    <div css={styles.pageHeadingCSS}>
      {hasCategoryDescription(categoryDescription) || categoryLinks ? (
        <>
          <Media lessThan={Breakpoint.L}>
            <Accordion {...accordionProps} isOpen={false}>
              <AccordionContent {...accordionContentProps} />
            </Accordion>
          </Media>
          <Media greaterThanOrEqual={Breakpoint.L}>
            <Accordion {...accordionProps} isOpen={openOnMount}>
              <AccordionContent {...accordionContentProps} />
            </Accordion>
          </Media>
        </>
      ) : (
        <div css={styles.pageHeadingWrapperCSS}>
          <h1>{categoryHeading}</h1>
        </div>
      )}
    </div>
  );
};
